export enum NotificationSortEnums {
  SENDER,
  SUBJECT,
  DATE,
}
